import { render, staticRenderFns } from "./customerState.vue?vue&type=template&id=41828277&scoped=true"
import script from "./customerState.vue?vue&type=script&lang=js"
export * from "./customerState.vue?vue&type=script&lang=js"
import style0 from "./customerState.vue?vue&type=style&index=0&id=41828277&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41828277",
  null
  
)

export default component.exports